import styled from "@emotion/styled";
import {Box} from "@mui/material";
import {media} from "assets/css/media";
import topLine from "assets/img/top_line_desktop.png";
import bottomLine from "assets/img/bottom_line_desktop.png";

export const MainWrapper = styled(Box)`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	background: #fff;
`;
export const AuthSection = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1 1 100%;
	padding: 5px 0;
	box-sizing: border-box;
	background: url(${topLine}) no-repeat right top, url(${bottomLine}) no-repeat left bottom,
		linear-gradient(204deg, #0041f9 0%, #0041f9 45%, #ff0019 75%, #ff0019 100%);
	background-size: 25%, 25%, cover;

	@media (max-width: ${media.mobile}) {
		background: url(${topLine}) no-repeat right top, url(${bottomLine}) no-repeat left bottom,
			linear-gradient(270deg, #0041f9 0%, #0041f9 18%, #ff0019 88%, #ff0019 100%);
		background-size: 40%, 40%, cover;
	}
`;
export const AuthWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px 20px 40px;
	gap: 20px;

	max-width: 600px;
	width: 100%;
	margin: 20px auto 20px;

	background: #fff;
	border: 1px solid #ffffff;
	border-radius: 8px;

	color: var(--thirdColor);
	font-family: var(--fontFamilySecond);

	@media (max-width: ${media.mobile}) {
		width: 94%;
	}

	form {
		width: 100%;
		max-width: 320px;
		margin: 0 auto;
		color: var(--thirdColor);

		h2 {
			font-family: var(--fontFamilyThird);
			font-style: normal;
			font-weight: 700;
			font-size: 32px;
			line-height: 104%;
			text-align: center;
			letter-spacing: -0.02em;
			text-transform: uppercase;
		}

		h6 {
			font-family: var(--fontFamilySecond);
			font-style: normal;
			font-weight: 500;
			font-size: 16px;
			line-height: 130%;
			text-align: center;
		}

		a {
			font-weight: 400;
		}

		.MuiInputBase-input {
			color: var(--thirdColor) !important;

			&:-webkit-autofill {
				color: var(--thirdColor) !important;
				-webkit-text-fill-color: var(--thirdColor);
			}
		}

		.MuiTextField-root,
		.MuiSelect-select {
			//background: rgba(255, 255, 255, 0.09);
			background: rgba(0, 0, 0, 0.1);
			border-radius: 4px 4px 0 0;
			color: var(--thirdColor);
		}

		.MuiSelect-select {
			color: var(--thirdColor);
		}

		.MuiInputBase-formControl {
			color: var(--thirdColor);

			&:after {
				//border-color: #c81414;
				border-color: var(--primaryColor);
			}

			svg {
				fill: var(--thirdColor);

				path {
					fill: var(--thirdColor);
				}
			}
		}

		.MuiInputLabel-formControl {
			color: #a3a3a3;
		}

		.MuiSwitch-track {
			background-color: #616d82;
		}

		.Mui-checked + .MuiSwitch-track {
			background-color: #4b2eb8;
		}

		.Mui-checked {
			.MuiSwitch-thumb {
				background-color: var(--primaryColor);
			}
		}
	}
`;

export const FormContainer = styled(Box)`
	width: 100%;
	max-width: 320px;
	margin: 0 auto;
	color: var(--thirdColor);
	font-family: var(--fontFamilySecond);
	display: flex;
	flex-direction: column;
	align-items: center;

	h2 {
		font-family: var(--fontFamilyThird);
		font-style: normal;
		font-weight: 700;
		font-size: 32px;
		line-height: 104%;
		text-align: center;
		letter-spacing: -0.02em;
		text-transform: uppercase;
		margin: 15px auto;
	}

	p {
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 350;
		font-size: 16px;
		line-height: 130%;
		text-align: center;
		color: var(--thirdColor);
	}
`;

export const LogoContainer = styled(Box)<{size: "lg" | "md" | "sm"}>`
	//background: #ff3af7;
	margin: 25px auto 0;
	box-sizing: border-box;
	padding: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	//svg {
	//	width: 121px;
	//}
`;
export const PageName = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	padding: 0 20px;
	gap: 10px;

	width: 100%;
	min-height: 158px;
	background: #003c82;
	border-bottom: 1px solid #ffffff;
	box-sizing: border-box;

	h2 {
		font-family: var(--fontFamilyThird);
		font-style: normal;
		font-weight: 700;
		font-size: 52px;
		line-height: 104%;
		letter-spacing: -0.02em;
		text-transform: uppercase;
		color: #ffffff;
	}
`;
